export const getErrorMessageFromAPI = ({ response }, customMessage) => {
  if (response?.data?.Message) {
    return response?.data?.Message;
  }
  if (response?.data?.message) {
    return response?.data?.message;
  }
  return response?.data?.length < 300 ? response?.data : customMessage ? customMessage : false;
};
